import { Value } from '@udecode/plate-common';
import { ELEMENT_PARAGRAPH } from '@udecode/plate-paragraph';

export const defaultText: Value = [
  {
    type: ELEMENT_PARAGRAPH,
    children: [{ text: '' }]
  }
];
